var _defs, _path, _path2, _path3, _g, _path4, _path5, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoClara(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 73.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#outer-glow-1);\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #f4f6f9;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-3 {\n        fill: #f4f6f9;\n      }\n\n      .cls-4 {\n        fill: #ec6a3c;\n        filter: url(#outer-glow-2);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-1",
    x: 274.2,
    y: 12.06,
    width: 55.92,
    height: 55.92,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#e9571d",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-2",
    x: 283.32,
    y: 20.94,
    width: 37.92,
    height: 37.92,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#e7451e",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.56.22H-.21v55.71c4.45-4.04,8.9-8.08,13.35-12.12.02-10.49.04-20.99.06-31.48h10.36c10.97,0,18.37,7.57,18.37,18.37v.17c0,10.8-7.4,18.19-18.37,18.19-3.18-.19-6.36-.39-9.53-.58-4.58,4.23-9.16,8.46-13.74,12.68h23.28c19.15,0,32.39-13.32,32.39-30.47v-.17C55.95,13.37,42.71.22,23.56.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.46,40.78l-.03-.17c-2-12.92,5.55-24.99,18.73-27.03,15.12-2.34,23.86,8.32,25.85,21.16.16,1.01.26,2.21.36,3.4l-31.5,4.88c2.17,5.63,6.7,8.04,12.44,7.15,1.71-.27,2.98-.76,4.73-1.48,2.25-.93,4.02-1.97,5.24-2.77,3.39.91,6.78,1.82,10.16,2.73-1.32,1.84-3.47,4.39-6.69,6.72-1.73,1.25-5.94,4.2-12.01,5.14-13.6,2.11-25.13-5.88-27.27-19.73ZM94.8,32.03c-1.65-5.63-5.63-8.99-11.04-8.15s-8.19,5.16-8.3,11.15l19.34-3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M247.2,12.67c-6.75,0-11.11,3.16-14.27,7.43v-6.58h-12.99v59.48h0c4.27-3.32,8.53-6.64,12.8-9.96.06-3.23.13-6.46.19-9.69,3.08,3.68,7.35,6.84,14.27,6.84,10.85,0,20.85-8.38,20.85-23.67v-.17c0-15.3-10.17-23.67-20.85-23.67ZM255.06,36.52c0,7.69-5.13,12.65-11.2,12.65s-11.11-5.04-11.11-12.65v-.17c0-7.61,5.04-12.65,11.11-12.65s11.2,5.04,11.2,12.65v.17Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M339.61,48.64v-21.71h-5.47v-11.11h5.47V4.11h12.99v11.71c4.76-.02,9.51-.03,14.27-.05-1.17,3.72-2.33,7.44-3.5,11.16h-10.77v19.57c0,2.99,1.28,4.44,4.19,4.44,2.39,0,4.53-.6,6.41-1.62v10.43c-2.73,1.62-5.9,2.65-10.26,2.65-7.95,0-13.33-3.16-13.33-13.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M376.2,48.79v-21.93c-3.14.06-6.28.12-9.42.18,1.3-3.8,2.59-7.6,3.89-11.41h5.53V3.81h13.12v11.83h10.88v11.22h-10.88v19.77c0,3.02,1.3,4.49,4.23,4.49,2.42,0,4.58-.6,6.48-1.64v10.53c-2.76,1.64-5.96,2.68-10.36,2.68-8.03,0-13.47-3.19-13.47-13.9Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.42,13.98c4.13,0,8.27,0,12.4-.01l10.26,30.68,10.34-30.68h12.58c-5.7,15.38-11.4,30.77-17.11,46.15h-11.79c-5.56-15.38-11.12-30.76-16.67-46.14Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.81,50.98c3.04-2.74,6.09-5.48,9.13-8.22,5.38,4.44,11.02,7.26,17.86,7.26,5.38,0,8.63-2.14,8.63-5.64v-.17c0-3.33-2.05-5.04-12.05-7.61-4.46-1.14-13.42-3.32-17.45-9.07-3.51-5-3.28-12.68-.11-18.17C170.71.93,181,.12,184.49.12c6.75,0,12.01,1.86,14.89,3.09,3.76,1.6,6.6,3.52,8.49,4.97-2.66,3.15-5.33,6.31-7.99,9.46-5.3-3.68-10.51-5.9-15.55-5.9s-7.69,2.31-7.69,5.21c0,.66.06,1.62.53,2.63,1.65,3.56,6.45,3.86,12.38,5.41,12.14,3.16,18.97,7.52,18.97,17.95v.17c-.02,2.37-.42,6.4-2.93,10.24-5.34,8.18-15.87,8.79-19.24,8.99-14.4.84-24.55-9.3-26.53-11.35Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 302.24,
    cy: 39.94,
    r: 26.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 302.24,
    cy: 39.94,
    r: 22.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 302.24,
    cy: 39.94,
    r: 17.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 302.24,
    cy: 39.94,
    r: 11.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 302.24,
    cy: 39.94,
    r: 3.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoClara);
export default __webpack_public_path__ + "static/media/logo-clara.85101207d382490443c6ccd0097727ed.svg";
export { ForwardRef as ReactComponent };